if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          return;
        }
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.dynamicCheckoutWrapper = this.querySelector('[data-dynamic-checkout-wrapper]');
        this.sectionContainer = this.closest('.shopify-section') || document;
        const requiredFieldsMessageFromSettings = (this.dataset.requiredFieldsMessage || '').trim();
        this.requiredFieldsMessage =
          requiredFieldsMessageFromSettings || 'Debes rellenar los campos obligatorios antes de proceder con la compra.';
        this.isBuyNowOnly = this.dataset.buyNowOnly === 'true';
        this.showRequiredFieldsErrorWhenInvalid = false;
        this.isShowingRequiredFieldsError = false;
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.boundUpdateDynamicCheckoutState = this.updateDynamicCheckoutState.bind(this);
        this.boundGlobalCheckoutGuard = this.handleGlobalCheckoutGuard.bind(this);

        if (this.dynamicCheckoutWrapper) {
          document.addEventListener('input', this.boundUpdateDynamicCheckoutState, true);
          document.addEventListener('change', this.boundUpdateDynamicCheckoutState, true);
          document.addEventListener('click', this.boundGlobalCheckoutGuard, true);
          document.addEventListener('submit', this.boundGlobalCheckoutGuard, true);

          this.updateDynamicCheckoutState();
        }
      }

      disconnectedCallback() {
        if (!this.dynamicCheckoutWrapper) return;
        document.removeEventListener('input', this.boundUpdateDynamicCheckoutState, true);
        document.removeEventListener('change', this.boundUpdateDynamicCheckoutState, true);
        document.removeEventListener('click', this.boundGlobalCheckoutGuard, true);
        document.removeEventListener('submit', this.boundGlobalCheckoutGuard, true);
      }

      onSubmitHandler(evt) {
        if (!this.submitButton) {
          if (!this.isDynamicCheckoutAttempt(evt)) {
            evt.preventDefault();
          }
          return;
        }
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const hasInvalidRequiredPropertyFields = this.hasInvalidRequiredPropertyFields();
        if (!this.form.checkValidity() || hasInvalidRequiredPropertyFields) {
          this.form.reportValidity();
          if (hasInvalidRequiredPropertyFields) {
            this.showRequiredFieldsErrorWhenInvalid = true;
            this.showRequiredFieldsError();
            this.updateDynamicCheckoutState();
          }
          return;
        }

        this.showRequiredFieldsErrorWhenInvalid = false;
        this.clearRequiredFieldsError();
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.isShowingRequiredFieldsError = false;
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (this.isBuyNowOnly) {
              window.location = '/checkout';
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            this.updateDynamicCheckoutState();
          });
      }

      updateDynamicCheckoutState() {
        if (!this.dynamicCheckoutWrapper || !this.form) return;

        const requiredPropertyFields = this.getRequiredPropertyFields();
        const hasRequiredFields = requiredPropertyFields.length > 0;
        const canBuyNow = !hasRequiredFields || requiredPropertyFields.every((field) => this.isRequiredPropertyFieldComplete(field));

        this.dynamicCheckoutWrapper?.classList.toggle('is-disabled', !canBuyNow);
        this.dynamicCheckoutWrapper?.setAttribute('aria-disabled', canBuyNow ? 'false' : 'true');
        this.dynamicCheckoutWrapper?.toggleAttribute('inert', !canBuyNow);

        if (canBuyNow) {
          this.showRequiredFieldsErrorWhenInvalid = false;
          this.clearRequiredFieldsError();
          return;
        }

        if (this.showRequiredFieldsErrorWhenInvalid) {
          this.showRequiredFieldsError();
        } else {
          this.clearRequiredFieldsError();
        }
      }

      handleGlobalCheckoutGuard(event) {
        if (!this.dynamicCheckoutWrapper || !this.form) return;
        if (!this.isDynamicCheckoutAttempt(event)) return;
        if (!this.hasInvalidRequiredPropertyFields()) return;

        this.showRequiredFieldsErrorWhenInvalid = true;
        this.form.reportValidity();
        this.showRequiredFieldsError();
        this.updateDynamicCheckoutState();

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
      }

      isDynamicCheckoutAttempt(event) {
        if (event.type === 'submit') {
          if (event.target !== this.form) return false;
          const submitter = event.submitter || document.activeElement;
          return Boolean(submitter && submitter.closest('.shopify-payment-button, .product-form__dynamic-checkout-wrapper'));
        }

        if (event.type !== 'click') return false;
        const target = event.target;
        if (!(target instanceof Element)) return false;

        const dynamicCheckoutTarget = target.closest(
          '.shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button__more-options, .product-form__dynamic-checkout-wrapper'
        );
        if (!dynamicCheckoutTarget) return false;

        const closestProductForm = dynamicCheckoutTarget.closest('product-form');
        if (closestProductForm && closestProductForm !== this) return false;

        return this.contains(dynamicCheckoutTarget);
      }

      getRequiredPropertyFields() {
        if (!this.form) return [];

        const inlineAthleteFields = Array.from(this.form.querySelectorAll('[required][data-athlete-required-field]'));
        const associatedAthleteFields = Array.from(
          this.sectionContainer.querySelectorAll(`[form="${this.form.id}"][required][data-athlete-required-field]`)
        );

        const inlinePropertyFields = Array.from(this.form.querySelectorAll('[required][name^="properties["]'));
        const associatedPropertyFields = Array.from(
          this.sectionContainer.querySelectorAll(`[form="${this.form.id}"][required][name^="properties["]`)
        );

        const requiredPropertyFields = [
          ...new Set([
            ...inlineAthleteFields,
            ...associatedAthleteFields,
            ...inlinePropertyFields,
            ...associatedPropertyFields
          ])
        ];

        return requiredPropertyFields.filter((field) => !field.disabled);
      }

      hasInvalidRequiredPropertyFields() {
        const requiredPropertyFields = this.getRequiredPropertyFields();
        if (!requiredPropertyFields.length) return false;

        return requiredPropertyFields.some((field) => !this.isRequiredPropertyFieldComplete(field));
      }

      isRequiredPropertyFieldComplete(field) {
        if (!field) return true;

        const fieldType = (field.type || '').toLowerCase();
        if (fieldType === 'checkbox' || fieldType === 'radio') {
          return field.checked && field.checkValidity();
        }

        if (typeof field.value === 'string' && field.value.trim() === '') {
          return false;
        }

        return field.checkValidity();
      }

      showRequiredFieldsError() {
        this.isShowingRequiredFieldsError = true;
        this.handleErrorMessage(this.requiredFieldsMessage);
      }

      clearRequiredFieldsError() {
        if (!this.isShowingRequiredFieldsError) return;
        this.isShowingRequiredFieldsError = false;
        this.handleErrorMessage();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) {
          return;
        }
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      
      get variantIdInput() {
        // return this.form.querySelector('[name=id]');
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
